import React, { useState, useEffect } from 'react'
import { makeStyles } from '@mui/styles';
import { Typography } from '@mui/material';
// import PassImage from '../shared/assets/pass_images/sotyktu_ios_pass.png';
import Sotyktu_iosPass from '../shared/assets/pass_images/sotyktu_ios_pass_mobile.png';
import Sotyktu_androidPass from '../shared/assets/pass_images/sotyktu_android_pass.png';
import Sotyktu_PassHeader from '../shared/assets/sotyktu_header.svg';

import Zeposia_iosPass from '../shared/assets/pass_images/zeposia_ios_pass_mobile.png';
import Zeposia_androidPass from '../shared/assets/pass_images/zeposia_android_pass.png';
import Zeposia_PassHeader from '../shared/assets/zeposia_header.svg';

import Camzyos_iosPass from '../shared/assets/pass_images/camzyos_ios_pass_mobile.svg';
import Camzyos_androidPass from '../shared/assets/pass_images/camzyos_android_pass.svg';
import Camzyos_PassHeader from '../shared/assets/camzyos_header.svg';

const useStyles = makeStyles(() => ({
    sotyktu_header1: {
        fontWeight: '600 !important',
        color: '#4933DA',
        lineHeight: '1.35 !important'
    },
    zeposia_header1: {
        fontWeight: '600 !important',
        color: '#0054A6',
        lineHeight: '1.35 !important'
    },
    androidBtn: {
        height: '60px',
        margin: '15px',
    },
    cardImage: {
        maxWidth: '350px',
        width: '85%',
        borderRadius: '8px',
        boxShadow: '0 3px 10px rgb(0 0 0 / 20%)'
    },
    cardImg: {
        maxWidth: '350px',
        width: '85%',
    }
}));

const PassDetails = (props) => {
    const classes = useStyles();
    const [pass, setPass] = useState();

    useEffect(() => {
        setPass(props.passname)
    }, [props.passname])

    const togglePassDetails = () => {
        switch (pass) {
            case 'Sotyktu':
                return <div>
                    <img style={{ height: '125px' }} src={Sotyktu_PassHeader} />
                    <hr
                        style={{
                            border: 0,
                            height: '7px',
                            background: 'linear-gradient(to right, #4933DA 0% ,#4933DA 50%, #D3019F 50%,#D3019F 75%, #96FF73 75% )',
                        }}
                    ></hr>
                    <br />
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                        <Typography variant='h6' className={classes.sotyktu_header1}>
                            Your Co-Pay Card is Available for Download in the {props.platform == 'iphone' ? 'Apple' : props.platform == 'android' ? 'Google' : 'Apple / Google'} Wallet!
                        </Typography>
                        <Typography variant='body'>
                            Thank You for activating your SOTYKTU Co-Pay Card. To add your card to the {props.platform == 'iphone' ? 'Apple' : props.platform == 'android' ? 'Google' : 'Apple / Google'} Wallet, press the Add to Wallet button below.
                        </Typography>
                        <div style={{ position: 'relative' }}>
                            <img
                                className={classes.cardImage}
                                src={props.platform == 'android' ? Sotyktu_androidPass : Sotyktu_iosPass}
                                alt="card"
                            />
                        </div >
                    </div>
                </div>
            case 'Zeposia':
                return <div>
                    <img style={{ height: '125px', width: '100%' }} src={Zeposia_PassHeader} />
                    {/* <hr
                        style={{
                            border: 0,
                            height: '7px',
                            background: 'linear-gradient(to right, #4933DA 0% ,#4933DA 50%, #D3019F 50%,#D3019F 75%, #96FF73 75% )',
                        }}
                    ></hr> */}
                    <br />
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                        <Typography variant='h6' className={classes.zeposia_header1}>
                            Your Co-pay Card is Available for Download in the {props.platform == 'iphone' ? 'Apple' : props.platform == 'android' ? 'Google' : 'Apple / Google'} Wallet!
                        </Typography>
                        <Typography variant='body'>
                            Thank you for activating your ZEPOSIA Co-pay Card. To add your card to the {props.platform == 'iphone' ? 'Apple' : props.platform == 'android' ? 'Google' : 'Apple / Google'} Wallet, press the Add to Wallet button below.
                        </Typography>
                        <div style={{ position: 'relative' }}>
                            <img
                                className={props.platform === 'android' ? classes.cardImg : classes.cardImage}
                                src={props.platform === 'android' ? Zeposia_androidPass : Zeposia_iosPass}
                                alt="card"
                            />
                        </div >
                    </div>
                </div>
            case 'Camzyos':
                return <div>
                    <img style={{ height: '125px', width: '100%' }} src={Camzyos_PassHeader} />
                    {/* <hr
                            style={{
                                border: 0,
                                height: '7px',
                                background: 'linear-gradient(to right, #4933DA 0% ,#4933DA 50%, #D3019F 50%,#D3019F 75%, #96FF73 75% )',
                            }}
                        ></hr> */}
                    <br />
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                        <Typography variant='h6' className={classes.zeposia_header1}>
                            Your Co-pay Program is Available for Download in the {props.platform == 'iphone' ? 'Apple' : props.platform == 'android' ? 'Google' : 'Apple / Google'} Wallet!
                        </Typography>
                        <Typography variant='body'>
                            Thank you for activating your CAMZYOS Co-pay Program. To add your card to the {props.platform == 'iphone' ? 'Apple' : props.platform == 'android' ? 'Google' : 'Apple / Google'} Wallet, press the Add to Wallet button below.
                        </Typography>
                        <div style={{ position: 'relative' }}>
                            <img
                                className={props.platform === 'android' ? classes.cardImg : classes.cardImage}
                                style={{ borderRadius: "12px" }}
                                src={props.platform === 'android' ? Camzyos_androidPass : Camzyos_iosPass}
                                alt="card"
                            />
                        </div >
                    </div>
                </div>
            default: break;
        }
    }

    return (
        <>
            {togglePassDetails()}
        </>
    )
}

export default PassDetails